import React from 'react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function CtaButton({
  children,
  className = '',
  onClick
}: CtaButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.2
  }} onClick={handleClick} className={`bg-gold hover:bg-gold-light text-navy px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-sans font-semibold text-base sm:text-lg shadow-lg transition-colors w-full sm:w-auto min-h-[48px] ${className}`} aria-label="Get instant access to the Mega Music Pack" data-id="element-49">
      {children}
    </motion.button>;
}